"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DuplicateVersionModel", {
    enumerable: true,
    get: function() {
        return DuplicateVersionModel;
    }
});
const _versionmodel = require("./version-model");
const DuplicateVersionModel = _versionmodel.VersionModel.pick({
    authorName: true,
    authorUserId: true
});

//# sourceMappingURL=duplicate-version-model.js.map